import React, { useState, useContext, useEffect} from 'react';
import MUIDataTable from 'mui-datatables';
import { Link as RouterLink } from 'react-router-dom';
import FormControlLabel from '@mui/material/FormControlLabel';
// material
import {
    Card,
    Stack,
    Alert,
    Button,
    Container,
    Typography,
    MenuItem,  
    ListItemIcon, 
    ListItemText,
    AlertTitle,
    TextField,
    Checkbox,
    Avatar
  } from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button';  

import {api, reiniciarToken, consultaProdutosFiltro, excluirProdutos} from '../../services/api';
// context
import { AuthContext } from '../../contexts/auth';  
// components
import Loading from '../../components/Loading';

import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import { fFormataDinheiro } from '../../utils/formatNumber';
import produtoPadrao from '../../images/produto_padrao.jpg';
import imagemServico from '../../images/imagem_servico.png';

export default function ConsultaProduto() {
  
  const { logout } = useContext(AuthContext);
  const [dados, setData] = useState([]);
  const [removeLoading, setRemoveLoading] = useState(true);
  const [descricaProdutoPesquisa, setDescricaoProduto] = useState('');
  const [movimentaEstoquePesquisa, setMovimentaEstoque] = useState(false);
  const [showElement, setShowElement] = useState(false);
  let imagemPadrao;

  const getProdutos = async () => {
    setData([]);
    const retorno = await reiniciarToken();
    setRemoveLoading(false);
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const response = await consultaProdutosFiltro(descricaProdutoPesquisa, movimentaEstoquePesquisa);
    
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      setRemoveLoading(true);
      response.data.forEach((valores) => {
        setData(dados => [...dados, {id_produto: valores.id_produto, 
                                     descricao: valores.descricao, 
                                     nome_fantasia: valores.nome_fantasia, 
                                     preco_custo: fFormataDinheiro(valores.preco_custo),
                                     preco_venda_inicial: fFormataDinheiro(valores.preco_venda_inicial),
                                     qtde_estoque: valores.qtde_estoque,
                                     url: valores.url}]);
      });
    }; 
  }

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  }) 
  
  
  const excluirProdutoServ = async (id) => {

    const response = await excluirProdutos(id);
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
      setData([]);
      getProdutos();
    }; 
  } 

  if (localStorage.getItem(['tipo_comercio']) === '1') {
    imagemPadrao = imagemServico;
  }else{
    imagemPadrao = produtoPadrao;   
  }

  useEffect(() => {
    if (localStorage.getItem(['tipo_comercio']) === '1') {
      setShowElement(true);
    }else{
      setShowElement(true);

      if (localStorage.getItem(['tipo_comercio']) === '3') {
          if (localStorage.getItem(['menu_restrito']) === '2') {
             setShowElement(true);
          }else{
             setShowElement(false);
          }
      }    
    }
  },[])
  
  let columns;
  if (showElement) {
    columns = [{name: "Ação",
                options: {
                  filter: false,
                  sort: false,
                  empty: true,
                  customBodyRenderLite: (dataIndex, rowIndex) =>  {
                    return (
                      <> 
                        <MenuItem onClick={() => excluirProdutoServ(dados[dataIndex].id_produto)} sx={{ color: 'text.secondary' }}>
                          <ListItemIcon>
                              <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                          </ListItemIcon>
                          <ListItemText primary="Excluir" primaryTypographyProps={{ variant: 'body2' }} />
                        </MenuItem>

                        <MenuItem component={RouterLink} to={`/produto/editar/${dados[dataIndex].id_produto}`} sx={{ color: 'text.secondary' }}>
                          <ListItemIcon>
                              <Iconify icon="eva:edit-fill" width={24} height={24} />
                          </ListItemIcon>
                          <ListItemText primary="Alterar" primaryTypographyProps={{ variant: 'body2' }} />
                        </MenuItem>
                      </> 
                    );
                  }
                }
              }
              ,{name: "",
                options: {
                  filter: false,
                  sort: false,
                  empty: true,
                  customBodyRenderLite: (dataIndex, rowIndex) =>  {
                    return (
                      <> 
                        <Avatar src={dados[dataIndex].url !== null ? dados[dataIndex].url : imagemPadrao} alt="imagemProduto" sx={{ width: 100, height: 100 }} />
                      </> 
                    );
                }
                }
              }
              ,{name:"id_produto", label: "Código"} 
              ,{name:"descricao", label: "Descrição"}
              ,{name:"nome_fantasia", label: "Fornecedor"}
              ,{name:"preco_custo", label: "Preço de Custo"}
              ,{name:"qtde_estoque", label: "Qtde Estoque"}
              ,{name: "",
                options: {
                  filter: false,
                  sort: false,
                  empty: true,
                  customBodyRenderLite: (dataIndex, rowIndex) =>  {
                    return (
                      <> 
                        <ThemeProvider theme={Theme}>
                          <Button variant="contained" color="neutral" component={RouterLink} to={`/imagens_produto/visualizar/${dados[dataIndex].id_produto}`}>
                            Imagens
                          </Button>
                        </ThemeProvider>
                      </> 
                    );
                  }
                }
              }
              ];
  }else{
    columns = [{name:"id_produto", label: "Código"} 
              ,{name: "",
                options: {
                  filter: false,
                  sort: false,
                  empty: true,
                  customBodyRenderLite: (dataIndex, rowIndex) =>  {
                    return (
                      <> 
                        <Avatar src={dados[dataIndex].url !== null? dados[dataIndex].url : imagemPadrao} alt="imagemProduto" sx={{ width: 100, height: 100 }} />
                      </> 
                    );
                }
                }
               }
              ,{name:"descricao", label: "Descrição"}
              ,{name:"preco_venda_inicial", label: "Preço de Venda"}
              ,{name:"qtde_estoque", label: "Qtde Estoque"}
              ,{name: "",
                options: {
                  filter: false,
                  sort: false,
                  empty: true,
                  customBodyRenderLite: (dataIndex, rowIndex) =>  {
                    return (
                      <> 
                        <ThemeProvider theme={Theme}>
                          <Button variant="contained" color="neutral" component={RouterLink} to={`/imagens_produto/visualizar/${dados[dataIndex].id_produto}`}>
                            Imagens
                          </Button>
                        </ThemeProvider>
                      </> 
                    );
                  }
                }
              }
              ];
  }

  const options = {
    filterType: "dropdown",
    tableBodyHeight: "100%",
    selectableRows: "none",
    responsive: "standard",
  }; 
                  
  return (
    <Page title="Produto">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Consulta de Produtos/Serviços
          </Typography>
          {!showElement && null}
          {showElement &&
            <ThemeProvider theme={Theme}>
              <Button variant="contained" color="neutral" component={RouterLink} to="/produto/cadastrar" startIcon={<Iconify icon="eva:plus-fill" />}>
                Novo Produto
              </Button>
            </ThemeProvider>
          }
        </Stack>
        <Stack mb={5} direction={{ xs: 'column', sm: 'row' }} alignItems="center" justifyContent="space-between" spacing={2}>
          <TextField 
            fullWidth
            label="Descrição Produto"
            value={descricaProdutoPesquisa}
            onChange={(newValue) => {
              setDescricaoProduto(newValue.target.value);
            }}
          />
          <FormControlLabel
            control={<Checkbox
              name="movimenta_estoque"
              checked={movimentaEstoquePesquisa}
              onChange={(newValue) => {
                setMovimentaEstoque(newValue.target.checked);
              }}
              />
            }
            label={<Typography>Movimenta Estoque</Typography>}
          />
          <ThemeProvider theme={Theme}>
            <Button fullWidth size="large" type="submit" variant="contained" color="neutral" onClick={getProdutos}>
              Consultar
            </Button>
          </ThemeProvider>
        </Stack>
        {!removeLoading && <Loading/>}
        {removeLoading && <Card>
            <Stack spacing={3}>
              {status.type === 'erro' ? <Alert severity="error"><AlertTitle>Erro</AlertTitle>{status.mensagem}</Alert> : ""}
              {status.type === 'success' ? <Alert severity="success"><AlertTitle>Sucesso</AlertTitle>{status.mensagem}</Alert> : ""}
            </Stack > 
            <MUIDataTable
                data={Object.values(dados)}
                columns={columns}  
                options={options} 
            />
        </Card>}
      </Container>  
    </Page>  
  );
}

